import { useMutation } from 'react-query';

import { reorderRankForStoredFilterBulkAssignTags as mutationFn } from 'api/endPoints/reorderRankForStoredFilterBulkAssignTags';

export const useMutationReorderRankForStoredFilterBulkAssignTags = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    idList: { id: number; rank: number }[];
    contractId: number;
}
